import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UserAccountService } from 'src/app/_Services/UserAccount/useraccount.service';
import { FBReportAccessType } from 'src/app/_Models/common/common.model';



@Component({
  selector: 'app-calenderaudit-report-details',
  templateUrl: './calenderaudit-report-details.component.html',
  styleUrls: ['./calenderaudit-report-details.component.scss']
})
export class CalenderauditReportDetailsComponent implements OnInit {

  
  
  _fbReportAccessType = FBReportAccessType;

  @Input() modelPopUp;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  constructor(public activeModel:NgbActiveModal,public accService: UserAccountService , translate: TranslateService,) { }

  ngOnInit(): void {
  }
  close()
  {
    this.activeModel.close(this.modelPopUp);

  }
 
  UpdateFilling(reportUrl) {   
      window.open(reportUrl, "_blank");      
  }
  getShortName(fullName) { 
    return fullName.substring(0, 1);
  }



  
RedirectToFbReport(reportId, fbReportAccessType) {
  this.accService.getUserTokenToFB()
    .subscribe(
      response => {
        if (response != null) {
         // window.open("https://filling.fullbridge.io/demo/app/report/112667/filling?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzUxMiJ9.eyJlbWFpbCI6InRlc3QtbGluay1zYWFzQGZic2Fhcy5jb20iLCJmaXJzdG5hbWUiOiJKYWNxdWVzIiwibGFzdG5hbWUiOiJEdXBvbnQiLCJyb2xlIjoiaW5zcGVjdG9yIn0.gUkh3_cttRtUOUW1qgLppdCqhNZ9UrY-KGZUYU7qO7VO97C7pV5MOz66Mph6MKwoA1-ArIl4NVakSmu6l4czqSILp2SjWPDuFnEftlq63gZqnnjOIFpspBq5G4891xQhIWawMbMsrwHFtsfLkQMTwiHljlmarhntlZBqdyDQ7ajVJxREkm2GPv2tr92aLr4rMEq-FUHxp15mqiaDqw_8cIggjeXHNbst1P-AhAAyAliutwwlWbq7_u51IFgIDWtgj-BK8jNSm2APaQ6PJ3ECiU7FKdd1KwhnjiAvJuNWKSG5LW1mEEJqJNHivLBhcXoUINTZeUNvsZMUJlxj328O3w", "_blank");
          if (fbReportAccessType == this._fbReportAccessType.Filling)
            window.open(response.auditReportUrl + reportId + "/filling" + "?token=" + response.token + "", "_blank");
            
          // else if (fbReportAccessType == this._fbReportAccessType.Review)
          //   window.open(response.reportUrl + reportId + "/review" + "?token=" + response.token + "", "_blank");
        }
      },
    );
}
}
